/**
 * Utility functions for subdomain detection
 */

/**
 * Check if the current hostname is the vitals subdomain
 *
 * @returns true if on vitals subdomain, false otherwise
 */
export const isVitalsSubdomain = (): boolean => {
  return (
    window.location.hostname === "vitals.circadia.link"
    // window.location.hostname === "172.20.10.2"
    // Note: Add localhost here if you want to test on localhost
  );
};
